import * as Lambda from '../../services/LambdaApi';

export type ResidentialFacilityListItem = {
    facilityId: string;
    facilityName: string;
    communityName: string;
    city?: string;
    state?: string;
    zip?: string;
    address?: string;
    paymentEnabled?: boolean;
};

export type GuestAccessState = {
    active: boolean;
    verified: boolean;
    paymentsRequired: boolean;
    subscriptionRequired: boolean;
    subscriptionActive: boolean;
    subscriptionStatus: string;
    pendingReason: string;
};

export type NeighborsIdentityResponse = {
    success: boolean;
    userType: 'resident' | 'guest';
    accountType: 'resident' | 'guest';
    needsOnboarding: boolean;
    profile: any;
    facility?: any;
    residentialCommunity?: any;
    subscription?: any;
    access: GuestAccessState;
};

export type GuestOnboardingPayload = {
    facilityId: string;
    FirstName: string;
    LastName: string;
    Email: string;
    Phone?: string;
    Address1?: string;
    Address2?: string;
    City?: string;
    State?: string;
    ZIP?: string;
    Image?: string;
    LoginMethod?: string;
};

export const fetchPublicResidentialFacilities = async (): Promise<ResidentialFacilityListItem[]> => {
    const response = await Lambda.Get('/users/neighbors/residential-facilities', {}, 'public');
    return Array.isArray(response?.facilities) ? response.facilities : [];
};

export const fetchNeighborsIdentity = async (): Promise<NeighborsIdentityResponse> => {
    return Lambda.Get('/users/neighbors/identity', {}, 'lambda');
};

export const completeGuestOnboarding = async (
    payload: GuestOnboardingPayload,
): Promise<NeighborsIdentityResponse> => {
    return Lambda.Post('/users/neighbors/guests/onboarding', payload, 'lambda');
};

export const deleteGuestAccount = async (): Promise<void> => {
    await Lambda.Delete('/users/neighbors/guests/account', {}, 'lambda');
};
